<template>
  <div class="card floating">
    <div class="card-content">
      <p>{{ $t('prompts.emptyTrashMessage') }}</p>
    </div>
    <div class="card-action">
      <button @click="$store.commit('closeHovers')" id ="buttonCancelDelete"
        class="button button--flat button--grey"
        :aria-label="$t('buttons.cancel')"
        :title="$t('buttons.cancel')">{{ $t('buttons.cancel') }}</button>
      <button @click="submit"
        class="button button--flat button--red" id ="buttonDelete"
        :aria-label="$t('buttons.delete')"
        :title="$t('buttons.delete')">{{ $t('buttons.delete') }}</button>
    </div>
  </div>
</template>

<script>
import { files as api } from '@/api';
import {mapGetters, mapState, mapMutations} from 'vuex';

export default {
  name: 'empty-trash',
  computed: {
    ...mapGetters(['isListing']),
    ...mapState(['req'])
  },
  methods: {
    ...mapMutations(['closeHovers']),
    submit: async function () {
      try {
        let promises = [];
        for (let item of this.req.items) {
          promises.push(api.removeId(item.handle));
        }

        await Promise.all(promises);
        this.closeHovers();
        this.$store.commit('setReload', true);
      } catch (e) {
        buttons.done('delete');
        this.closeHovers();
        this.$showError(e);
        if (this.isListing) this.$store.commit('setReload', true);
      }
    }
  },
};
</script>